import {ACTION_CATEGORY, ANALYTICS_MODULE} from 'analytics/AnalyticsTypes';

// Keep in sync with benchling/analytics/lib/analysis_tool_analytics_events.py
export const ANALYSIS_TOOL_ANALYTICS_ACTIONS = {
  SELECTED_DATA_FRAME_CREATION_METHOD: {
    module: ANALYTICS_MODULE.ANALYSIS_TOOL,
    action: 'selected_data_frame_creation_option',
    actionCategory: ACTION_CATEGORY.READ,
  },
  RESULTS_COLUMNS_MAPPED: {
    module: ANALYTICS_MODULE.ANALYSIS_TOOL,
    action: 'results_columns_mapped',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  /**
   * Action for clicking "Analysis key" button
   *
   * Analysis keys were originally specifc to steps and called analysis step keys. When we made this change
   * we chose to keep the event since it mostly represents the same action and will keep the data in the same
   * place.
   */
  COPIED_ANALYSIS_STEP_KEY: {
    module: ANALYTICS_MODULE.ANALYSIS_TOOL,
    action: 'copied_analysis_step_key',
    actionCategory: ACTION_CATEGORY.READ,
  },
  SELECTED_SIDEBAR_ITEM: {
    module: ANALYTICS_MODULE.ANALYSIS_TOOL,
    action: 'selected_sidebar_item',
    actionCategory: ACTION_CATEGORY.READ,
  },
  CLICKED_GIVE_FEEDBACK: {
    module: ANALYTICS_MODULE.ANALYSIS_TOOL,
    action: 'clicked_give_feedback',
    actionCategory: ACTION_CATEGORY.READ,
  },
  CLICKED_FLOWCHART_ACTION: {
    module: ANALYTICS_MODULE.ANALYSIS_TOOL,
    action: 'clicked_flowchart_action',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  CLICKED_REFRESH_DATA: {
    module: ANALYTICS_MODULE.ANALYSIS_TOOL,
    action: 'clicked_refresh_data',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  TRIGGERED_STEP_RERUN: {
    module: ANALYTICS_MODULE.ANALYSIS_TOOL,
    action: 'triggered_step_rerun',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  DISMISSED_CUSTOM_CODE_SURVEY_CALLOUT: {
    module: ANALYTICS_MODULE.ANALYSIS_TOOL,
    action: 'dismissed_custom_code_survey_callout',
    actionCategory: ACTION_CATEGORY.READ,
  },
  CLICKED_CUSTOM_CODE_SURVEY_LINK: {
    module: ANALYTICS_MODULE.ANALYSIS_TOOL,
    action: 'clicked_custom_code_survey_link',
    actionCategory: ACTION_CATEGORY.READ,
  },
  PUBLISHED_ANALYSIS_TEMPLATE: {
    module: ANALYTICS_MODULE.ANALYSIS_TOOL,
    action: 'published_analysis_template',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
};

/**
 * Enum for the rerun trigger source included in client-side analytics event metadata.
 */
export const RERUN_SOURCE = {
  /** User right-clicked (or otherwise selected) a step in the flowchart and chose "Rerun". */
  STEP: 'STEP',
  /** User edited the step config and saved, which triggers a rerun. */
  CONFIG: 'CONFIG',
  /** User clicked the rerun button above a dataset table / data view. */
  TABLE: 'TABLE',
};

export type RerunSource = (typeof RERUN_SOURCE)[keyof typeof RERUN_SOURCE];
